if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          button: this.querySelector('.disclosure__button'),
          panel: this.querySelector('.disclosure__list'),
          input: this.querySelector('input[name="country_code"], input[name="locale_code"]'),
          closeBtn: this.querySelector('.modal__close-button'),
          searchInput: this.querySelector('.dd-searchbox'),
        };

        this.elements.panel.style.display = 'none';

        this.elements.button.addEventListener('click', this.openDropdown.bind(this));
        document.addEventListener('click', this.handleClickOutside.bind(this));

        if (this.elements.closeBtn) {
          this.elements.closeBtn.addEventListener('click', this.closeDropdown.bind(this));
        }

        this.querySelectorAll('.disclosure__link').forEach((link) => {
          link.addEventListener('click', this.onItemClick.bind(this));
        });

        if (this.elements.searchInput) {
          this.elements.searchInput.addEventListener('input', this.onSearch.bind(this));
        }
      }

      openDropdown(event) {
        event.stopPropagation();
        const isVisible = this.elements.panel.style.display === 'block';
        if (isVisible) {
          this.closeDropdown();
        } else {
          this.elements.panel.style.display = 'block';
          this.elements.panel.removeAttribute('hidden');
          requestAnimationFrame(() => {
            this.elements.panel.classList.add('open');
            this.elements.button.setAttribute('aria-expanded', 'true');
          });
          if (this.elements.searchInput) {
            this.elements.searchInput.value = '';
            this.onSearch();
            this.elements.searchInput.focus();
          }
        }
      }

      closeDropdown() {
        this.elements.panel.classList.remove('open');
        this.elements.button.setAttribute('aria-expanded', 'false');
        setTimeout(() => {
          this.elements.panel.style.display = 'none';
        }, 250);
      }

      handleClickOutside(event) {
        if (!this.contains(event.target)) {
          this.closeDropdown();
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const value = event.currentTarget.dataset.value;
        if (!value || !this.elements.input) return;
        this.elements.input.value = value;
        const form = this.querySelector('form');
        if (form) form.submit();
      }

      onSearch() {
        const query = (this.elements.searchInput.value || '').toLowerCase().trim();
        const items = this.querySelectorAll('.disclosure__item');
        const noResults = this.querySelector('.disclosure__no-results');
        let visibleCount = 0;

        items.forEach((item) => {
          const name = (item.textContent || '').toLowerCase();
          const match = !query || name.includes(query);
          item.style.display = match ? '' : 'none';
          if (match) visibleCount++;
        });

        if (noResults) {
          noResults.classList.toggle('hide', visibleCount > 0);
        }
      }
    }
  );
}
